import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { CompanyService } from '../services/company.service';
import { AccountCompany } from '../models/account-company.model';

@Injectable()
export class CompanyResolver  {
  constructor(private companyService: CompanyService) { }

  resolve() {
    return this.companyService.getCompany();
  }
}
